<template>
  <div class="wrapper">
    <!-- 标题区域 -->
    <div class="page-header">
      <div class="header-content">
        <h2 class="page-title">
          <i class="el-icon-s-goods title-icon"></i>
          {{ $route.meta.name }}
        </h2>
        <div class="header-stats">
          <div class="stat-item">
            <span class="stat-label">总记录数</span>
            <span class="stat-value">{{ total }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 搜索区域 -->
    <el-card class="search-card" shadow="never">
      <div class="card-header-title">
        <i class="el-icon-search"></i>
        <span>筛选条件</span>
      </div>
      <div class="header-search">
        <el-form ref="form" inline :model="searchData" label-width="100px">
          <el-form-item label="商品名称">
            <el-input 
              v-model="searchData.goodsTitle" 
              size="small" 
              placeholder="请输入商品名称"
              style="width: 220px"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品分类">
            <SelectGoodsCategory v-model="searchData.categoryId" style="width: 220px"></SelectGoodsCategory>
          </el-form-item>
          <el-form-item label="首页推荐">
            <el-select 
              v-model="searchData.enableHomeRecommend" 
              placeholder="请选择" 
              size="small" 
              clearable
              style="width: 220px"
            >
              <el-option label="是" :value="1"> </el-option>
              <el-option label="否" :value="0"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" " label-width="50px">
            <el-button 
              type="primary" 
              size="small" 
              icon="el-icon-search" 
              @click="getGoodsList"
              class="search-btn"
            >
              搜索
            </el-button>
            <el-button 
              type="info" 
              size="small" 
              icon="el-icon-refresh" 
              @click="reset"
              class="reset-btn"
            >
              重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <!-- 标签页和表格区域 -->
    <el-card class="table-card" shadow="never">
      <div class="card-header-title">
        <i class="el-icon-s-grid"></i>
        <span>商品列表</span>
        <div class="header-actions">
          <el-button
            v-checkbtn="isShowBtn(AUTH_BTN.mall_goods_list_add)"
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="$router.push({ name: 'MallGoodsAdd' })"
            class="add-btn"
            >新增</el-button
          >
        </div>
      </div>
      
      <div class="status-tabs-wrapper">
        <el-radio-group v-model="searchData.status" size="small" @input="getGoodsList" class="status-tabs">
          <el-radio-button :label="null">全部</el-radio-button>
          <el-radio-button :label="1">已上架</el-radio-button>
          <el-radio-button :label="0">已下架</el-radio-button>
        </el-radio-group>
      </div>
      
      <tp-table
        ref="goodsTable"
        :tableData="list"
        :columns="columns"
        :totalNum="total"
        :current-page.sync="currentPage"
        :pageSize.sync="pageSize"
        @handleSortChange="handleSortChange"
      />
    </el-card>

    <!-- 权重配置 -->
    <el-dialog title="权重配置" :visible.sync="dialogWeight" class="weight-dialog" width="500px">
      <div class="dialog-content">
        <el-form ref="formWeight" :model="goodsInfo" label-width="120px">
          <el-form-item label="当前权重">
            <span class="current-weight">{{ goodsInfo.weight || '-' }}</span>
          </el-form-item>
          <el-form-item label="权重设置">
            <el-input-number 
              v-model="goodsInfo.newWeight" 
              placeholder="请输入权重" 
              :min="1" 
              :max="999"
              :controls="false"
              class="weight-input"
            ></el-input-number>
            <span class="form-tip">范围：1-999</span>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogWeight = false" size="small" class="cancel-btn">取 消</el-button>
        <el-button type="primary" @click="submitWeight" size="small" class="submit-btn">提 交</el-button>
      </div>
    </el-dialog>

    <div style="height:60px;"></div>
  </div>
</template>

<script>
import {
  getGoodsListAPI,
  deleteGoodsAPI,
  changeStatusAPI,
  changeHomeRecommendAPI,
  changeHomeHotAPI,
  changeWeightAPI,
} from './api';
import SelectGoodsCategory from '@/views/components/select-goods-category.vue';
import { authBtnMixin } from '@/mixins/authBtnMixin';

const columns = [
  {
    label: 'ID',
    prop: 'id',
    minWidth: '80',
    customRender(h, row) {
      return <p class="table-cell-text">{row['id'] || '-'}</p>
    }
  },
  {
    label: '商品分类',
    prop: 'category',
    minWidth: '120',
    customRender(h, row) {
      return <p class="table-cell-text">{row['category']?.['categoryName'] || '-'}</p>
    }
  },
  {
    label: '品牌',
    prop: 'brand',
    minWidth: '120',
    customRender(h, row) {
      return <p class="table-cell-text">{row['brandName'] || '-'}</p>
    }
  },
  {
    label: '商品名称',
    prop: 'goodsTitle',
    minWidth: '200',
    customRender(h, row) {
      return (
        <div class="goods-name-cell">
          <p class="goods-title">{row['goodsTitle'] || '-'}</p>
          <p class="goods-subtitle">{row['subTitle'] || ''}</p>
        </div>
      )
    }
  },
  {
    label: '库存',
    prop: 'stockNum',
    minWidth: '100',
    customRender(h, row) {
      return <p class="table-cell-text">{row['stockNum'] || 0}</p>
    }
  },
  {
    label: '权重',
    prop: 'weight',
    minWidth: '100',
    sortable: 'custom',
    customRender(h, row) {
      return <el-tag size="mini" type="info">{row['weight'] || 0}</el-tag>
    }
  },
  {
    label: '首页热门',
    prop: 'enableHomeHot',
    minWidth: '120',
    customRender(h, row) {
      return (
        <div>
          <el-switch
            disabled={!this.isShowBtn(this.AUTH_BTN.mall_goods_list_home_hot)}
            class="switch"
            onChange={() => this.changeHomeHot(row)}
            v-model={row['enableHomeHot']}
            active-value={true}
            inactive-value={false}
            active-text="打开"
            inactive-text="关闭"
          ></el-switch>
        </div>
      )
    }
  },
  {
    label: '首页推荐',
    prop: 'enableHomeRecommend',
    minWidth: '120',
    customRender(h, row) {
      return (
        <div>
          <el-switch
            disabled={!this.isShowBtn(this.AUTH_BTN.mall_goods_list_home_recommend)}
            class="switch"
            onChange={() => this.changeHomeRecommend(row)}
            v-model={row['enableHomeRecommend']}
            active-value={true}
            inactive-value={false}
            active-text="打开"
            inactive-text="关闭"
          ></el-switch>
        </div>
      )
    }
  },
  {
    label: '状态',
    prop: 'status',
    minWidth: '120',
    customRender(h, row) {
      return (
        <div>
          <el-switch
            disabled={!this.isShowBtn(this.AUTH_BTN.mall_goods_list_status)}
            class="switch"
            onChange={() => this.changeStatus(row)}
            v-model={row['status']}
            active-value={1}
            inactive-value={0}
            active-text="上架"
            inactive-text="下架"
          ></el-switch>
        </div>
      )
    }
  },
  {
    label: '创建时间',
    prop: 'createTime',
    minWidth: '180',
    customRender(h, row) {
      return <p class="table-cell-text">{row['createTime'] || '-'}</p>
    }
  },
  {
    label: '操作',
    width: '180',
    fixed: 'right',
    customRender(h, row) {
      return (
        <div class="action-links">
          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.mall_goods_list_edit)}
            underline={false}
            type="primary"
            onClick={() => this.$router.push({ name: 'MallGoodsEdit', params: { id: row['id'] } })}
            class="action-link"
          >
            编辑
          </el-link>

          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.mall_goods_list_weight)}
            underline={false}
            type="primary"
            onClick={() => this.handleWeight(row)}
            class="action-link"
          >
            权重
          </el-link>

          <el-link
            disabled={row['status'] == 1 || !this.isShowBtn(this.AUTH_BTN.mall_goods_list_del)}
            underline={false}
            type="primary"
            onClick={() => this.handleDel(row['id'])}
            class="action-link"
          >
            删除
          </el-link>
        </div>
      )
    }
  }
];

export default {
  name: 'MallGoodsList',
  components: { SelectGoodsCategory },
  mixins: [authBtnMixin],
  data() {
    return {
      dialogVisible: false,
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        categoryId: '',
        goodsTitle: '',
        status: null,
        goodsCombo: '',
        sortField: '',
        enableHomeRecommend: null,
      },
      dialogWeight: false,
      goodsInfo: {},
    }
  },
  provide() {
    return {
      context: this
    }
  },
  activated() {
    this.getGoodsList();
  },
  watch: {
    currentPage() {
      this.getGoodsList();
    },
    pageSize() {
      this.getGoodsList();
    }
  },
  mounted() {
    window['getBpageList'] = () => {
      this.getGoodsList();
    }
  },

  methods: {
    async getGoodsList() {
      const { categoryId, goodsTitle, status, goodsCombo, enableHomeRecommend, sortField } = this.searchData;
      let params = {
        categoryId,
        goodsTitle,
        status,
        goodsCombo,
        enableHomeRecommend,
        sortField,
        page: this.currentPage,
        pageSize: this.pageSize
      };
      const res = await getGoodsListAPI(params);
      this.list = res.list || [];
      this.total = res.total;
    },
    handleSortChange(column) {
      if (column) {
        let sortWay = column.order == 'ascending' ? '+' : '-';
        this.searchData.sortField = column.prop + sortWay;
        this.getGoodsList();
      }
    },
    // 编辑
    handleEdit() {},
    // 状态
    changeStatus(row) {
      let { id, status } = row;
      let data = { id, status: status == 0 ? 0 : 1 };
      let statusDesc = status == 0 ? '下架' : '上架';

      this.$confirm(`此操作将该商品${statusDesc}吗, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          row.status = status == 0 ? 0 : 1;
          changeStatusAPI(data).then(() => {
            this.getGoodsList();
            this.$message.success('操作成功');
          })
        })
        .catch(() => {
          row.status = status == 1 ? 0 : 1;
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        })
    },
    // 是否首页推荐
    changeHomeRecommend(row) {
      let { id, enableHomeRecommend } = row;
      let data = { id, enableHomeRecommend };
      let desc = enableHomeRecommend ? '打开': '关闭';

      this.$confirm(`此操作将${desc}首页推荐, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          row.enableHomeRecommend = enableHomeRecommend;
          changeHomeRecommendAPI(data).then(() => {
            this.getGoodsList();
            this.$message.success('操作成功');
          })
        })
        .catch(() => {
          row.enableHomeRecommend = !enableHomeRecommend;
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        })
    },
    // 是否首页热门
    changeHomeHot(row) {
      let { id, enableHomeHot } = row;
      let data = { id, enableHomeHot };
      let desc = enableHomeHot ? '打开': '关闭';

      this.$confirm(`此操作将${desc}首页热门, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            row.enableHomeHot = enableHomeHot;
            changeHomeHotAPI(data).then(() => {
              this.getGoodsList();
              this.$message.success('操作成功');
            })
          })
          .catch(() => {
            row.enableHomeHot = !enableHomeHot;
            this.$message({
              type: 'info',
              message: '已取消操作'
            });
          })
    },
    // 删除
    handleDel(id) {
      this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteGoodsAPI(id).then(() => {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            this.getGoodsList();
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        })
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.$refs.goodsTable.handleSortClear();
      this.getGoodsList();
    },
    handleWeight(row) {
      this.goodsInfo = row;
      this.dialogWeight = true;
    },
    submitWeight() {
      let data = {
        id: this.goodsInfo.id,
        weight: this.goodsInfo.newWeight,
      };
      changeWeightAPI(data).then(() => {
        this.$message.success('操作成功');
        this.getGoodsList();
        this.dialogWeight = false;
        this.goodsInfo = {};
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: linear-gradient(180deg, #f0f2f5 0%, #fafbfc 50%, #ffffff 100%);
  padding: 20px;
  min-height: calc(100vh - 84px);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.02) 100%);
    pointer-events: none;
    z-index: 0;
  }
}

// 页面标题区域
.page-header {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
  }
  
  .page-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1a1e25;
    display: flex;
    align-items: center;
    gap: 12px;
    letter-spacing: -0.5px;
    
    .title-icon {
      font-size: 24px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
  
  .header-stats {
    display: flex;
    gap: 24px;
    
    .stat-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      padding: 4px 14px;
      background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
      border-radius: 10px;
      border: 1px solid rgba(64, 158, 255, 0.15);
      
      .stat-label {
        font-size: 12px;
        color: #909399;
        margin-right: 8px;
      }
      
      .stat-value {
        font-size: 16px;
        font-weight: 700;
        color: #409EFF;
        line-height: 1;
      }
    }
  }
}

// 卡片标题样式
.card-header-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f2f5;
  
  i {
    font-size: 18px;
    color: #409EFF;
  }
  
  .header-actions {
    display: flex;
    gap: 12px;
    margin-left: auto;
    
    .add-btn {
      border-radius: 10px;
      padding: 9px 20px;
      font-weight: 600;
      font-size: 13px;
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      
      &:hover:not(.is-disabled) {
        transform: translateY(-2px);
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
      }
      
      &.is-disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
}

// 搜索卡片样式
.search-card {
  margin-bottom: 20px;
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  ::v-deep .el-card__body {
    padding: 24px 28px;
  }

  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 15px;
        margin-bottom: 10px;
        
        .el-form-item__label {
          color: #303133;
          font-weight: 600;
          letter-spacing: 0.3px;
          font-size: 14px;
          position: relative;
          
          &::after {
            content: ':';
            margin-left: 2px;
            color: #909399;
          }
        }
        
        .el-input,
        .el-select {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          
          .el-input__inner {
            border-radius: 10px;
            height: 38px;
            line-height: 38px;
            border: 1.5px solid #E4E7ED;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            background: #fafbfc;
            font-size: 13px;

            &:hover {
              border-color: #C0C4CC;
              background: #ffffff;
            }
          }
          
          &.is-active .el-input__inner,
          .el-input__inner:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
            background: #ffffff;
          }
        }
      }
      
      .search-btn {
        border-radius: 10px;
        padding: 10px 24px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
        border: none;
        box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;

        &:hover {
          background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
          box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
        }
      }

      .reset-btn {
        border-radius: 10px;
        padding: 10px 24px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
        border: none;
        box-shadow: 0 4px 12px rgba(144, 147, 153, 0.25);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;

        &:hover {
          background: linear-gradient(135deg, #909399 0%, #82848a 100%);
          box-shadow: 0 6px 16px rgba(144, 147, 153, 0.35);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
        }
      }
    }
  }
}

// 表格卡片样式
.table-card {
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #67C23A 0%, #85ce61 50%, #95d475 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  ::v-deep .el-card__body {
    padding: 24px;
  }
  
  .status-tabs-wrapper {
    margin-bottom: 20px;
    padding: 16px;
    background: #fafbfc;
    border-radius: 10px;
    border: 1px solid #e4e7ed;
    
    .status-tabs {
      ::v-deep .el-radio-button {
        .el-radio-button__inner {
          border-radius: 8px;
          padding: 8px 20px;
          font-weight: 500;
          transition: all 0.3s ease;
          border: 1.5px solid #E4E7ED;
          background: #ffffff;
          
          &:hover {
            color: #409EFF;
            border-color: #409EFF;
          }
        }
        
        .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
          border-color: #409EFF;
          color: #ffffff;
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
        }
      }
    }
  }

  ::v-deep .tp-table {
    .el-table {
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid #EBEEF5;
      background: #ffffff;

      th {
        background: linear-gradient(180deg, #F8FAFF 0%, #F0F4FF 100%);
        color: #303133;
        font-weight: 700;
        padding: 18px 0;
        border-bottom: 2px solid #E4E7ED;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        font-size: 12px;
        
        &:first-child {
          padding-left: 20px;
        }
      }

      tbody {
        tr {
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          border-bottom: 1px solid #F0F2F5;

          &:hover > td {
            background: linear-gradient(90deg, #F5F7FA 0%, #FAFBFC 100%) !important;
          }
          
          &:last-child {
            border-bottom: none;
          }

          td {
            padding: 18px 0;
            border-bottom: 1px solid #F5F7FA;
            
            &:first-child {
              padding-left: 20px;
            }
            
            .table-cell-text {
              margin: 0;
              color: #606266;
              font-size: 13px;
              line-height: 1.8;
              font-weight: 400;
            }
            
            .goods-name-cell {
              .goods-title {
                margin: 0 0 4px 0;
                color: #303133;
                font-weight: 600;
                font-size: 14px;
              }
              
              .goods-subtitle {
                margin: 0;
                color: #909399;
                font-size: 12px;
              }
            }
            
            .action-links {
              display: flex;
              flex-wrap: wrap;
              gap: 8px;
              
              .action-link {
                font-weight: 500;
                transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                
                &:hover:not(.is-disabled) {
                  transform: translateY(-1px);
                  color: #66b1ff;
                }
                
                &.is-disabled {
                  opacity: 0.5;
                  cursor: not-allowed;
                }
              }
            }
          }
        }
      }
    }

    .pagination {
      margin-top: 24px;
      padding: 20px 0 0;
      border-top: 2px solid #F0F2F5;
      
      ::v-deep .el-pagination {
        .el-pagination__total {
          color: #606266;
          font-weight: 500;
        }
        
        .btn-prev,
        .btn-next {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            background: #F5F7FA;
            color: #409EFF;
          }
        }
        
        .el-pager li {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            color: #409EFF;
            background: #F5F7FA;
          }
          
          &.active {
            background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
            color: #ffffff;
            font-weight: 600;
            box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
          }
        }
        
        .el-select .el-input__inner {
          border-radius: 6px;
          border-color: #DCDFE6;
          
          &:hover {
            border-color: #C0C4CC;
          }
        }
        
        .el-input__inner {
          border-radius: 6px;
          border-color: #DCDFE6;
          
          &:hover {
            border-color: #C0C4CC;
          }
          
          &:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
          }
        }
      }
    }
  }
}

// switch按钮样式
::v-deep .switch {
  .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }

  .el-switch__label--right {
    z-index: 1;
  }

  .el-switch__label--right span {
    margin-left: 5px;
  }

  .el-switch__label--left {
    z-index: 1;
  }

  .el-switch__label--left span {
    margin-left: 20px;
  }

  .el-switch__label.is-active {
    display: block;
  }

  .el-switch__core,
  .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}

// 权重对话框样式
::v-deep .weight-dialog {
  .el-dialog {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15), 0 4px 16px rgba(0, 0, 0, 0.1);
    
    .el-dialog__header {
      padding: 24px 28px;
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      border-bottom: 2px solid #f0f2f5;
      
      .el-dialog__title {
        font-size: 18px;
        font-weight: 700;
        color: #1a1e25;
      }
    }
    
    .el-dialog__body {
      padding: 0;
    }
    
    .el-dialog__footer {
      padding: 20px 28px;
      background: linear-gradient(135deg, #fafbfc 0%, #f5f7fa 100%);
      border-top: 2px solid #f0f2f5;
    }
  }
}

.dialog-content {
  padding: 24px 28px;
  
  .el-form-item {
    margin-bottom: 24px;
    
    .el-form-item__label {
      color: #303133;
      font-weight: 600;
      font-size: 14px;
    }
    
    .current-weight {
      font-size: 18px;
      font-weight: 700;
      color: #409EFF;
    }
    
    .weight-input {
      width: 200px;
      
      ::v-deep {
        .el-input-number__decrease,
        .el-input-number__increase {
          display: none;
        }
        
        .el-input__inner {
          border-radius: 10px;
          height: 42px;
          line-height: 42px;
          border: 1.5px solid #E4E7ED;
          padding: 0 15px;
          box-sizing: border-box;
        }
      }
    }
    
    .form-tip {
      margin-left: 12px;
      font-size: 12px;
      color: #909399;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  
  .cancel-btn {
    border-radius: 10px;
    padding: 10px 24px;
    font-weight: 600;
    font-size: 13px;
    background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
    border: none;
    box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    
    &:hover {
      background: linear-gradient(135deg, #909399 0%, #82848a 100%);
      box-shadow: 0 4px 12px rgba(144, 147, 153, 0.35);
      transform: translateY(-2px);
    }
  }
  
  .submit-btn {
    border-radius: 10px;
    padding: 10px 24px;
    font-weight: 600;
    font-size: 13px;
    background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
    border: none;
    box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    
    &:hover {
      background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
      box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
      transform: translateY(-2px);
    }
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .search-card .header-search .el-form ::v-deep {
    .el-form-item {
      margin-right: 12px;
    }
  }
  
  .page-header .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    
    .header-stats {
      width: 100%;
      justify-content: flex-start;
    }
  }
}

@media (max-width: 768px) {
  .wrapper {
    padding: 12px;
  }
  
  .page-header .header-content {
    padding: 16px;
    
    .page-title {
      font-size: 20px;
    }
  }
  
  .search-card,
  .table-card {
    border-radius: 12px;
    
    ::v-deep .el-card__body {
      padding: 16px;
    }
  }
  
  .card-header-title {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    
    .header-actions {
      width: 100%;
      flex-wrap: wrap;
    }
  }
}
</style>
